// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./font.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/icon_filedown_w@3x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/icon_btn_prev.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/icon_btn_prev_dis.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

/* common */
body .viewer {
  font-family: "NotoSansKR", sans-serif;
  font-weight: 400;
  letter-spacing: -0.4px;
  line-height: 1.2;
  word-break: break-all;
  color: #2a2c2f;
  margin: 0;
  padding: 0;
}

/*content*/
.viewer {
  /* height: 100vh; */
  /* background: #2a303b; */
  overflow-y: hidden;
}
.viewer__top {
  position: fixed;
  width: calc(100% - 40px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: #252b34;
  border-bottom: 1px solid #38404d;
  z-index: 10;
}
.viewer__top h1 {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.25rem;
  display: flex;
  align-items: center;
  letter-spacing: -0.025rem;
  color: #fff;
}
.viewer__top .top__right {
  display: flex;
  align-items: center;
}
.viewer__top .top__right img {
  opacity: 0.3;
  width: 46px;
  height: 22px;
}
.viewer__top .top__right button {
  width: 120px;
  height: 32px;
  background: transparent;
  border: 0;
  margin-right: 1rem;

  cursor: pointer;
}
.viewer__top .top__right button:hover {
  background-color: #171a20;
}
.viewer__top .top__right button span {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  line-height: 1rem;
  letter-spacing: -0.025rem;
  color: #fff;
}
.viewer__top .top__right button span::after {
  content: "";
  margin-left: 0.563rem;
  width: 1.313rem;
  height: 1.313rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: 100%;
}
.viewer .paging__area {
  display: flex;
  align-items: center;
}
.viewer .paging__area p {
  font-size: 0.875rem;
  line-height: 1rem;
  letter-spacing: -0.025rem;
  color: #fff;
  margin-right: 0.813rem;
}
.viewer .paging__button {
  display: flex;
  align-items: center;
}
.viewer .paging__button li {
  list-style: none;
}
.viewer .paging__area a {
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.025rem;
  color: #fff;
}
.viewer .btn-prev a,
.viewer .btn-next a {
  font-size: 0;
}
.viewer .btn-prev {
  width: 28px;
  height: 28px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(180deg);
}
.viewer .btn-next {
  width: 28px;
  height: 28px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center;
  background-size: 100%;
}
.viewer .btn-prev.disabled {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(0deg);
}
.viewer .btn-next.disabled {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
  background-size: 100%;
  transform: rotate(180deg);
}
.viewpaging__select span {
  margin-right: 14px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.025rem;
  color: #fff;
}
.viewpaging__select input[type="text"] {
  padding: 0 7px;
  width: 24px;
  height: 28px;
  border: 1px solid #171a20;
  border-radius: 4px;
  background: #171a20;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.025rem;
  color: #fff;
  text-align: right;
}
.viewer__document {
  display: block;
  margin: 53px auto 0;
  padding: 0 0 53px;
  text-align: center;
  /* width: calc(100% - 118px);
  height: calc(100vh - 100px); */
  background: #2a303b;
  overflow-y: scroll;
}
.viewer__document img {
  width: calc(100% - 118px);
  margin: 0 auto;
}
.viewer__document .react-pdf__Document {
  width: calc(100% - 118px);
  margin: 0 auto;
}
.viewer__document .react-pdf__Page__canvas {
  width: 100% !important;
}
.viewer__bottom {
  display: none;
  align-items: center;
  margin: 20px 25px;
}
.viewer__bottom span {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.viewer__bottom span img {
  width: 100px;
  height: auto;
}
.viewer__bottom .paging {
  font-weight: 400;
  font-size: 12px;
  color: #a4b0c3;
}

@media screen and (max-width: 870px) {
  .viewer__top h1 {
    width: 60%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }
  .viewer .paging__area p {
    display: none;
  }
  .viewer__top .top__right img {
    display: none;
  }
  .viewer__top .top__right button {
    width: 33px;
    margin-right: 0;
  }
  .viewer__top .top__right button span {
    font-size: 0;
  }
  .viewer__top .top__right button span::after {
    margin-left: 0;
  }
  .viewer__document {
    padding: 0;
    background: #fff;
    border-top: 10px solid #2a303b;
  }
  .viewer__document img {
    width: 100%;
  }
  .viewer__document .react-pdf__Document {
    width: 100%;
  }
  .viewer__bottom {
    display: flex;
  }
}
@media screen and (max-width: 500px) {
  .viewer__top h1 {
    width: 40%;
  }
}
@media screen and (max-width: 350px) {
  .viewer__top h1 {
    width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./static/css/viewer.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAGhB,WAAW;AACX;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;;EAElB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2EAAwE;EACxE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,2EAAmE;EACnE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,2EAAmE;EACnE,qBAAqB;AACvB;AACA;EACE,2EAAuE;EACvE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,2EAAuE;EACvE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB;gCAC8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["@charset \"UTF-8\";\r\n@import url(font.css);\r\n\r\n/* common */\r\nbody .viewer {\r\n  font-family: \"NotoSansKR\", sans-serif;\r\n  font-weight: 400;\r\n  letter-spacing: -0.4px;\r\n  line-height: 1.2;\r\n  word-break: break-all;\r\n  color: #2a2c2f;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/*content*/\r\n.viewer {\r\n  /* height: 100vh; */\r\n  /* background: #2a303b; */\r\n  overflow-y: hidden;\r\n}\r\n.viewer__top {\r\n  position: fixed;\r\n  width: calc(100% - 40px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 20px;\r\n  background: #252b34;\r\n  border-bottom: 1px solid #38404d;\r\n  z-index: 10;\r\n}\r\n.viewer__top h1 {\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  line-height: 1.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n}\r\n.viewer__top .top__right {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.viewer__top .top__right img {\r\n  opacity: 0.3;\r\n  width: 46px;\r\n  height: 22px;\r\n}\r\n.viewer__top .top__right button {\r\n  width: 120px;\r\n  height: 32px;\r\n  background: transparent;\r\n  border: 0;\r\n  margin-right: 1rem;\r\n\r\n  cursor: pointer;\r\n}\r\n.viewer__top .top__right button:hover {\r\n  background-color: #171a20;\r\n}\r\n.viewer__top .top__right button span {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.875rem;\r\n  line-height: 1rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n}\r\n.viewer__top .top__right button span::after {\r\n  content: \"\";\r\n  margin-left: 0.563rem;\r\n  width: 1.313rem;\r\n  height: 1.313rem;\r\n  background: url(\"../img/icon_filedown_w@3x.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.viewer .paging__area {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.viewer .paging__area p {\r\n  font-size: 0.875rem;\r\n  line-height: 1rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n  margin-right: 0.813rem;\r\n}\r\n.viewer .paging__button {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.viewer .paging__button li {\r\n  list-style: none;\r\n}\r\n.viewer .paging__area a {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  line-height: 1rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n}\r\n.viewer .btn-prev a,\r\n.viewer .btn-next a {\r\n  font-size: 0;\r\n}\r\n.viewer .btn-prev {\r\n  width: 28px;\r\n  height: 28px;\r\n  background: url(\"../img/icon_btn_prev.png\") no-repeat center center;\r\n  background-size: 100%;\r\n  transform: rotate(180deg);\r\n}\r\n.viewer .btn-next {\r\n  width: 28px;\r\n  height: 28px;\r\n  background: url(\"../img/icon_btn_prev.png\") no-repeat center center;\r\n  background-size: 100%;\r\n}\r\n.viewer .btn-prev.disabled {\r\n  background: url(\"../img/icon_btn_prev_dis.png\") no-repeat center center;\r\n  background-size: 100%;\r\n  transform: rotate(0deg);\r\n}\r\n.viewer .btn-next.disabled {\r\n  background: url(\"../img/icon_btn_prev_dis.png\") no-repeat center center;\r\n  background-size: 100%;\r\n  transform: rotate(180deg);\r\n}\r\n.viewpaging__select span {\r\n  margin-right: 14px;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  line-height: 1rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n}\r\n.viewpaging__select input[type=\"text\"] {\r\n  padding: 0 7px;\r\n  width: 24px;\r\n  height: 28px;\r\n  border: 1px solid #171a20;\r\n  border-radius: 4px;\r\n  background: #171a20;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  line-height: 1rem;\r\n  letter-spacing: -0.025rem;\r\n  color: #fff;\r\n  text-align: right;\r\n}\r\n.viewer__document {\r\n  display: block;\r\n  margin: 53px auto 0;\r\n  padding: 0 0 53px;\r\n  text-align: center;\r\n  /* width: calc(100% - 118px);\r\n  height: calc(100vh - 100px); */\r\n  background: #2a303b;\r\n  overflow-y: scroll;\r\n}\r\n.viewer__document img {\r\n  width: calc(100% - 118px);\r\n  margin: 0 auto;\r\n}\r\n.viewer__document .react-pdf__Document {\r\n  width: calc(100% - 118px);\r\n  margin: 0 auto;\r\n}\r\n.viewer__document .react-pdf__Page__canvas {\r\n  width: 100% !important;\r\n}\r\n.viewer__bottom {\r\n  display: none;\r\n  align-items: center;\r\n  margin: 20px 25px;\r\n}\r\n.viewer__bottom span {\r\n  width: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.viewer__bottom span img {\r\n  width: 100px;\r\n  height: auto;\r\n}\r\n.viewer__bottom .paging {\r\n  font-weight: 400;\r\n  font-size: 12px;\r\n  color: #a4b0c3;\r\n}\r\n\r\n@media screen and (max-width: 870px) {\r\n  .viewer__top h1 {\r\n    width: 60%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n  }\r\n  .viewer .paging__area p {\r\n    display: none;\r\n  }\r\n  .viewer__top .top__right img {\r\n    display: none;\r\n  }\r\n  .viewer__top .top__right button {\r\n    width: 33px;\r\n    margin-right: 0;\r\n  }\r\n  .viewer__top .top__right button span {\r\n    font-size: 0;\r\n  }\r\n  .viewer__top .top__right button span::after {\r\n    margin-left: 0;\r\n  }\r\n  .viewer__document {\r\n    padding: 0;\r\n    background: #fff;\r\n    border-top: 10px solid #2a303b;\r\n  }\r\n  .viewer__document img {\r\n    width: 100%;\r\n  }\r\n  .viewer__document .react-pdf__Document {\r\n    width: 100%;\r\n  }\r\n  .viewer__bottom {\r\n    display: flex;\r\n  }\r\n}\r\n@media screen and (max-width: 500px) {\r\n  .viewer__top h1 {\r\n    width: 40%;\r\n  }\r\n}\r\n@media screen and (max-width: 350px) {\r\n  .viewer__top h1 {\r\n    width: 30%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
